import * as yup from 'yup';
import { RapidCroVideoHeroContentTest } from '@web/components';
import {
  linkSchema,
  createInlineRichTextFromCMSSchema,
  inlineRichTextFromCMSSchema,
} from '../schemas';
import { schema as emailCaptureSchema } from './email_capture';
import { schema as muxVideoSchema } from './mux_video';
import { schema as listSchema } from './list';

export const component = RapidCroVideoHeroContentTest;

export const schema = yup
  .object({
    reviewsLink: linkSchema,
    eyebrowText: yup.string().nullable(),
    headline: yup.mixed().when('level', {
      is: val => !!val,
      then: yup.lazy((_, ctx) => {
        return createInlineRichTextFromCMSSchema(ctx.parent.level);
      }),
      otherwise: inlineRichTextFromCMSSchema, // Default schema if `level` is not provided
    }),
    subheadline: yup.string().nullable(),
    cta: yup.lazy(item => {
      switch (item?.component) {
        case 'email_capture':
          return emailCaptureSchema;
        default:
          return linkSchema;
      }
    }),
    valuePropsList: listSchema,
    backgroundColor: yup.string(),
    fontColor: yup.string(),
    starColor: yup.string(),
    horizontalOrientation: yup.mixed().oneOf(['left', 'center', 'right']),
    ctaColor: yup.string(),
    video: muxVideoSchema,
    level: yup.string().nullable(),
  })
  .transform(value => ({
    reviewsLink: value.reviews_link[0],
    eyebrowText: value.eyebrow_text,
    headline: value.headline,
    subheadline: value.subheadline,
    valuePropsList: value.value_props_list[0] || undefined,
    cta: value.cta[0] || undefined,
    backgroundColor: value.background_color || undefined,
    fontColor: value.font_color || undefined,
    horizontalOrientation: value.horizontal_orientation,
    ctaColor: value.cta_color || undefined,
    video: value.video[0],
    level: value.level,
    starColor: value.star_color || undefined,
  }));
